import {post} from '@/utils/request';

// 新增数据
export function RolesAdd(Data) {
  return post('/Roles/Add', Data); 
}
// 修改数据
export function RolesUpdate(Data) {
  return post('/Roles/Update', Data); 
}
// 删除数据
export function RolesDel(Data) {
  return post('/Roles/Del', Data); 
}
// 数据列表
export function RolesList(Data) {
  return post('/Roles/List', Data); 
}
// 下拉获取信息
export function RolesPullDown(Data) {
  return post('/Roles/PullDown', Data); 
}

// 授权菜单列表
export function RolePermissionsList(Data) {
  return post('/RolePermissions/List', Data); 
}

